export default {"src":"/_next/static/media/relay.12dbcec2.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};